import assignSubjectTeacherListSlice from '../../slices/assign/assignSubjectTeacher/AssignSubjectTeacherList';
import assignSubjectTeacherDetailsSlice from '../../slices/assign/assignSubjectTeacher/AssignSubjectTeacherDetails';
import assignCourseSubjectListSlice from '../../slices/assign/assignCourseSubject/AssignCourseSubjectList';
import assignCourseSubjectDetailsSlice from '../../slices/assign/assignCourseSubject/AssignCourseSubjectDetails';

const assignReducer = {
    assignAssignSubjectTeacherList: assignSubjectTeacherListSlice,
    assignAssignSubjectTeacherDetails: assignSubjectTeacherDetailsSlice,
    assignAssignCourseSubjectList: assignCourseSubjectListSlice,
    assignAssignCourseSubjectDetails: assignCourseSubjectDetailsSlice,
};

export default assignReducer;
